export default function LegalDisclaimer() {
  return (
    <section
      data-testid="legal-disclaimer"
      className="py-16 bg-cool-white border-y border-[#8A97A8]/20"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="reveal max-w-4xl text-cool-grey text-[12.5px] leading-relaxed space-y-3">
          <p className="font-mono-data uppercase tracking-[0.28em] text-navy-deep font-semibold">
            IN-VITRO RESEARCH ONLY
          </p>
          <p>
            <strong>FDA Disclaimer:</strong> These statements have not been
            evaluated by the U.S. Food and Drug Administration. Products offered
            by Aeonyx Life Sciences are not intended to diagnose, treat, cure,
            or prevent any disease.
          </p>
          <p>
            All products supplied by Aeonyx are sold strictly as reference
            materials for scientific laboratory research. Not for human or
            animal consumption, cosmetic use, or as dietary supplements.
          </p>
          <p>
            As a chemical supplier, Aeonyx does not provide dosing,
            reconstitution or medical guidance. Researchers assume full
            responsibility for handling all materials in accordance with their
            institution&apos;s safety protocols and applicable law. By purchasing,
            you indemnify Aeonyx Life Sciences from any misuse or off-label
            application of these materials.
          </p>
        </div>
      </div>
    </section>
  );
}
